import { DB } from '@/extensions/db'
import { Device } from './device'
import { newGuid } from '../utils'

let instance = null

export class PlcDevice {
  constructor () {
    instance = instance || this

    this._table = DB.plcDevice
    this._device = new Device()

    return instance
  }

  /**
   * @param [string] options.name
   * @param [string] options.manufacturer
   * @param [string] options.connectionType
   * @param [string] options.interfaceType
   * @param [number] options.interface
   * @param [Object] options.args
   * @param [Object] options.module
   *
   * @returns [number] device id
   */
  async add (options) {
    let id = await this._device.add({ type: 'plc' })

    return this._table.add({
      id: newGuid(),
      deviceId: id,
      name: options.name,
      model: options.model,
      manufacturer: options.manufacturer,
      connectionType: options.connectionType,
      interfaceType: options.interfaceType,
      interface: options.interface,
      args: options.args,
      module: options.module
    })
  }

  async get (id) {
    return this._table.get({ id })
  }

  async update (id, options) {
    return this._table.update({ id }, {
      name: options.name,
      model: options.model,
      manufacturer: options.manufacturer,
      connectionType: options.connectionType,
      interfaceType: options.interfaceType,
      interface: options.interface,
      args: options.args,
      module: options.module
    })
  }

  async delete (id) {
    let deviceId = (await this.get(id)).deviceId

    await this._device.delete(deviceId)
    return this._table.delete(id)
  }

  async all () {
    return this._table.toArray()
  }

  async interfaceId (id) {
    return this._table.where({ interface: id }).toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/plc-device.js